<script type="text/ecmascript-6">

    import {mapGetters} from "vuex";

    export default {
        /**
         * Computed these properties.
         */
        computed: {
            ...mapGetters({
                isPreview: 'getIsPreview',
                ownPage: 'getOwnPage',
            })
        },


        methods: {
            subIsActive(input) {
                const paths = Array.isArray(input) ? input : [input];
                return paths.some(path => {
                    return this.$route.path.indexOf(path) === 0 // current path starts with this path string
                })
            }
        }
    }
</script>

<template>
    <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar" v-show="!isPreview">

        <!-- Sidebar - Brand -->
        <router-link class="sidebar-brand d-flex align-items-center justify-content-center" tag="a" :to="{ name : 'home' }">
            <div class="sidebar-brand-icon rotate-n-15">
                <i class="fas fa-award"></i>
            </div>
            <div class="sidebar-brand-text mx-3">Mocha</div>
        </router-link>

        <!-- Divider -->
        <hr class="sidebar-divider my-0">


        <router-link tag="li" :to="{ name : 'my-projects' }" class="nav-item" exact>
            <a href="#" class="nav-link"><i class="fas fa-fw fa-folder"></i><span>My Projects</span></a>
        </router-link>

        <!-- Divider -->
        <hr class="sidebar-divider">

        <!-- Heading -->
        <div class="sidebar-heading">
            Reports
        </div>

        <router-link tag="li" :to="{ name : 'home' }" class="nav-item" exact>
            <a href="#" class="nav-link"><i class="fas fa-fw fa-tachometer-alt"></i><span>Dashboard</span></a>
        </router-link>

        <router-link tag="li" :to="{ name : 'media-spend' }" class="nav-item" exact>
            <a href="#" class="nav-link"><i class="fas fa-fw fa-hashtag"></i><span>Media Spend</span></a>
        </router-link>

        <router-link tag="li" :to="{ name : 'social-media' }" class="nav-item" exact>
            <a href="#" class="nav-link"><i class="fas fa-fw fa-hashtag"></i><span>Social Media</span></a>
        </router-link>

        <router-link tag="li" :to="{ name : 'competitor-benchmark' }" class="nav-item" exact>
            <a href="#" class="nav-link"><i class="fas fa-fw fa-hashtag"></i><span>Competitor Benchmark</span></a>
        </router-link>
        <router-link tag="li" :to="{ name : 'content-performance' }" class="nav-item" exact>
            <a href="#" class="nav-link"><i class="fas fa-fw fa-hashtag"></i><span>Content Performance</span></a>
        </router-link>

    </ul>
</template>
